// @flow

export default `
  CircleCI
  Greenkeeper
  browserslist
  config
  GraphQL
  iOS
  macOS
  monorepo
  psirenny
`;
